module.exports = __webpack_public_path__ + "img/icon_3_1.23167062.png";